module.exports = __webpack_public_path__ + "static/img/pic15.acf3da0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic15.png
// module id = P3s/
// module chunks = 0